/**
 * Classe para representar um plano
 */
class Plan {
  constructor(id, nome, valor, limite, isNotifyLimitations = true, isForSale = true) {
    this.id = id
    this.nome = nome
    this.valor = valor
    this.limite = limite
    this.isNotifyLimitations = isNotifyLimitations
    this.isForSale = isForSale
  }

  /**
   * Retorna o nome do plano formatado com prefixo "Plano"
   * @returns {string} Nome formatado do plano
   */
  getNomeFormatado() {
    return `Plano ${this.nome}`
  }
}

/**
 * Lista de todos os planos disponíveis
 */
const PLANOS = [
  new Plan(1, 'Essencial', 80, 6, true),
  new Plan(2, 'Ideal', 0, 0, true, false),
  new Plan(3, 'Exclusivo', 125, 6, false),
  new Plan(6, 'Enterprise', 125, 6, false),
]

/**
 * Utilitários para gerenciar planos
 */
export const PlanUtils = {
  /**
   * Busca um plano pelo ID
   * @param {number} id - ID do plano
   * @returns {Plan|null} Plano encontrado ou null se não existir
   */
  buscarPlanoPorId(id) {
    return PLANOS.find(plano => plano.id === id) || null
  },

  /**
   * Retorna o nome formatado de um plano pelo ID
   * @param {number} id - ID do plano
   * @returns {string} Nome formatado do plano ou 'Plano não encontrado'
   */
  obterNomePlanoFormatado(id) {
    const plano = this.buscarPlanoPorId(id)
    return plano ? plano.getNomeFormatado() : 'Plano não encontrado'
  },

  /**
   * Retorna todos os planos disponíveis
   * @returns {Plan[]} Array com todos os planos
   */
  obterTodosPlanos() {
    return [...PLANOS]
  },

  /**
   * Retorna apenas os planos disponíveis para venda
   * @returns {Plan[]} Array com planos disponíveis para venda
   */
  obterPlanosDisponiveis() {
    return PLANOS.filter(plano => plano.isForSale)
  },

  /**
   * Verifica se um plano existe
   * @param {number} id - ID do plano
   * @returns {boolean} True se o plano existir
   */
  planoExiste(id) {
    return this.buscarPlanoPorId(id) !== null
  },
}

export { Plan }
export default PlanUtils
